// Keuzes van de ISDE-subsidiecheck. Waarden komen overeen met de backend (isde_engine.CheckIn).
import { HOME_TYPES } from "../wizard/wizardOptions";

export const ISDE_STEPS = [
  { title: "Voor welke woning wilt u subsidie controleren?", short: "Woning" },
  { title: "Wat wilt u laten vervangen?", short: "Werkzaamheden" },
  { title: "Hoeveel vierkante meter wilt u ongeveer vervangen?", short: "Oppervlakte" },
  { title: "Planning en andere maatregelen", short: "Planning" },
  { title: "Uw persoonlijke uitkomst", short: "Uitkomst" },
];

export const YN = [{ id: "ja", label: "Ja" }, { id: "nee", label: "Nee" }, { id: "onbekend", label: "Weet ik niet" }];
export const WORK_STATUS = [{ id: "gepland", label: "Nog gepland" }, { id: "uitgevoerd", label: "Al uitgevoerd" }];
export const ISDE_HOME_TYPES = HOME_TYPES;
export const VVE = [
  { id: "eigen_appartement", label: "Ik geef zelf opdracht voor mijn appartement" },
  { id: "vve_gezamenlijk", label: "De VvE vervangt de kozijnen" },
  { id: "onbekend", label: "Weet ik nog niet" },
];
export const ISDE_PRODUCTS = [
  { id: "kunststof_hr_plus_plus", label: "Kunststof kozijnen met HR++" },
  { id: "kunststof_hr_triple", label: "Kunststof kozijnen met HR+++" },
  { id: "aluminium_hr_plus_plus", label: "Aluminium kozijnen met HR++" },
  { id: "aluminium_hr_triple", label: "Aluminium kozijnen met HR+++" },
  { id: "schuifpui", label: "Nieuwe schuifpui ter vervanging van een bestaande pui" },
  { id: "deur", label: "Nieuwe isolerende deur" },
  { id: "meerdere", label: "Meerdere verschillende producten" },
  { id: "onbekend", label: "Ik weet het nog niet" },
];
export const MATERIALS = [{ id: "kunststof", label: "Kunststof" }, { id: "aluminium", label: "Aluminium" }, { id: "onbekend", label: "Weet ik nog niet" }];
export const GLASS = [{ id: "hr_plus_plus", label: "HR++ glas" }, { id: "hr_triple", label: "HR+++ triple glas" }, { id: "onbekend", label: "Weet ik nog niet" }];
export const REPLACES = [{ id: "ja", label: "Ja, complete nieuwe kozijnen" }, { id: "nee", label: "Nee, alleen het glas" }, { id: "onbekend", label: "Weet ik niet" }];
export const OPENING = [
  { id: "bestaand", label: "Bestaande kozijnen of puien vervangen" },
  { id: "deels", label: "Deels bestaand, deels een nieuwe opening" },
  { id: "nieuw", label: "Een nieuwe gevelopening, aanbouw of dakkapel" },
  { id: "onbekend", label: "Weet ik nog niet" },
];
export const DOOR_CLASS = [{ id: "high", label: "Ud 1,0 of lager" }, { id: "low", label: "Ud tussen 1,0 en 1,5" }, { id: "none", label: "Hoger dan 1,5" }, { id: "onbekend", label: "Weet ik niet" }];
export const PANEL_CLASS = [{ id: "high", label: "Up 0,7 of lager" }, { id: "low", label: "Up tussen 0,7 en 1,2" }, { id: "none", label: "Hoger dan 1,2" }, { id: "onbekend", label: "Weet ik niet" }];
export const AREA_MODES = [
  { id: "m2", label: "Ik vul het oppervlak zelf in" },
  { id: "maten", label: "Breedte en hoogte per kozijn" },
  { id: "onbekend", label: "Ik weet de afmetingen nog niet" },
];
export const FRAME_KINDS = [{ id: "glas", label: "Kozijn met glas" }, { id: "glas_hr", label: "Kozijn met HR++ glas" }, { id: "deur", label: "Deur" }, { id: "paneel", label: "Dicht paneel" }];
export const plannedOptions = (y) => [
  { id: "dit_jaar", label: `Nog in ${y}` }, { id: "volgend_jaar", label: `In ${y + 1}` },
  { id: "later", label: `Later dan ${y + 1}` }, { id: "onbekend", label: "Weet ik nog niet" },
];
export const COMBI = [
  { id: "dak", label: "Dakisolatie" }, { id: "gevel", label: "Gevelisolatie" }, { id: "vloer", label: "Vloerisolatie" },
  { id: "bodem", label: "Bodemisolatie" }, { id: "spouw", label: "Spouwmuurisolatie" }, { id: "warmtepomp", label: "Warmtepomp" },
  { id: "zonneboiler", label: "Zonneboiler" }, { id: "warmtenet", label: "Aansluiting op een warmtenet" }, { id: "ventilatie", label: "Ventilatie" },
  { id: "geen", label: "Geen andere maatregelen" }, { id: "onbekend", label: "Nog niet bekend" },
];
export const QUALIFYING = ["dak", "gevel", "vloer", "bodem", "spouw", "warmtepomp", "zonneboiler", "warmtenet"];
export const PREVIOUS = [
  { id: "nee", label: "Nee" },
  { id: "ja_binnen", label: "Ja, één keer, en het eerste glas is minder dan 24 maanden geleden geplaatst" },
  { id: "ja_buiten", label: "Ja, langer geleden of al twee keer" },
  { id: "onbekend", label: "Weet ik niet" },
];

let seq = 0;
export const newFrame = () => ({ key: `f${Date.now()}-${seq++}`, kind: "glas", width: "", height: "", quantity: "1" });

export const EMPTY_ISDE = {
  owner: null, main_residence: null, build_year: "", build_unknown: false, permit_before: null, monument: null, home_type: null, vve: null,
  work_status: null, woonplaats: "", product: null, material: null, glass: null, ug_value: "", replaces_frames: null, opening: null,
  door_class: null, panels: null, panel_class: null, area_mode: null, glass_m2: "", glass_hr_m2: "", door_m2: "", panel_m2: "", frames: [newFrame()],
  excluded_m2: "", execution_date: "", planned_year: null, executed_by_company: null, purchase_before_transition: null, combination: [],
  combination_within: null, previous_glass: null,
};

const PRODUCT_GLASS = { kunststof_hr_plus_plus: "hr_plus_plus", kunststof_hr_triple: "hr_triple", aluminium_hr_plus_plus: "hr_plus_plus", aluminium_hr_triple: "hr_triple" };
export const productGlass = (p) => PRODUCT_GLASS[p];
export const tripleSelected = (f) => (PRODUCT_GLASS[f.product] || f.glass) === "hr_triple";
export const doorRelevant = (f) => f.product === "deur" || f.product === "meerdere" || (f.area_mode === "maten" && f.frames.some((x) => x.kind === "deur"));
export const num = (v, max = 500) => {
  const n = parseFloat(String(v ?? "").replace(",", "."));
  return Number.isFinite(n) && n >= 0 ? Math.min(n, max) : null;
};
const int = (v) => (/^\d+$/.test(String(v).trim()) ? parseInt(v, 10) : null);

export const frameError = (x) => {
  const w = int(x.width), h = int(x.height), q = int(x.quantity);
  if (!x.width && !x.height) return "";
  if (!w || w < 100 || w > 12000) return "Breedte tussen 100 en 12.000 mm";
  if (!h || h < 100 || h > 6000) return "Hoogte tussen 100 en 6.000 mm";
  if (!q || q < 1 || q > 50) return "Aantal tussen 1 en 50";
  return "";
};
export const validFrames = (frames) => frames.filter((x) => x.width && x.height && !frameError(x))
  .map((x) => ({ kind: x.kind, width_mm: int(x.width), height_mm: int(x.height), quantity: int(x.quantity) || 1 }));
export const framesM2 = (frames) => validFrames(frames).reduce((s, x) => s + (x.width_mm * x.height_mm * x.quantity) / 1e6, 0);

const yn = (v) => v || "onbekend";
export const buildCheckPayload = (f, mixed = false) => {
  const by = int(f.build_year);
  const done = f.work_status === "uitgevoerd";
  const ug = num(f.ug_value, 6);
  return {
    owner: yn(f.owner), main_residence: f.owner === "nee" ? "onbekend" : yn(f.main_residence),
    build_year: f.build_unknown || !by || by < 1000 || by > 2100 ? null : by, permit_before: yn(f.permit_before), monument: yn(f.monument),
    home_type: f.home_type || "onbekend", vve: f.home_type === "appartement" ? yn(f.vve) : "onbekend", work_status: f.work_status || "onbekend",
    product: f.product || "onbekend", material: f.material || "onbekend", glass: productGlass(f.product) || f.glass || "onbekend",
    ug_value: ug && ug >= 0.1 ? ug : null, replaces_frames: yn(f.replaces_frames), opening: f.opening || "onbekend",
    door_class: f.door_class || "onbekend", panel_class: f.panels === "ja" ? yn(f.panel_class) : "onbekend",
    area_mode: f.area_mode || "onbekend", glass_m2: f.area_mode === "m2" ? num(f.glass_m2) : null,
    glass_hr_m2: f.area_mode === "m2" && mixed ? num(f.glass_hr_m2) : null,
    door_m2: f.area_mode === "m2" && doorRelevant(f) ? num(f.door_m2, 100) : null, panel_m2: f.area_mode === "m2" && f.panels === "ja" ? num(f.panel_m2, 100) : null,
    frames: f.area_mode === "maten" ? validFrames(f.frames).filter((x) => (x.kind !== "paneel" || f.panels === "ja") && (x.kind !== "glas_hr" || mixed)) : [],
    excluded_m2: f.opening === "deels" ? num(f.excluded_m2) : null,
    execution_date: done ? f.execution_date : "", planned_year: done ? "onbekend" : f.planned_year || "onbekend",
    executed_by_company: done ? yn(f.executed_by_company) : "onbekend", purchase_before_transition: yn(f.purchase_before_transition),
    combination: f.combination, combination_within: yn(f.combination_within), previous_glass: f.previous_glass || "onbekend",
  };
};

const material = (f) => (f.product?.startsWith("kunststof") ? "kunststof" : f.product?.startsWith("aluminium") ? "aluminium" : f.material !== "onbekend" ? f.material : null);
const wizardProduct = (f) => {
  const m = material(f);
  if (productGlass(f.product)) return `${m}_kozijnen`;
  if (f.product === "schuifpui") return m ? `${m}_schuifpui` : null;
  if (f.product === "deur") return m ? `${m}_deur` : null;
  return f.product === "meerdere" ? "meerdere_kozijnen" : null;
};
const timeline = (planned) => {
  const left = 11 - new Date().getMonth();
  if (planned === "dit_jaar") return left <= 3 ? "1-3m" : left <= 6 ? "3-6m" : null;
  if (planned === "volgend_jaar") return left >= 6 ? "6m+" : null;
  return { later: "6m+", onbekend: "orienterend" }[planned] || null;
};
const KIND_LABEL = { deur: " (deur)", paneel: " (paneel)", glas: "", glas_hr: " (HR++ glas)" };

// Gegevens die de offertewizard overneemt, zodat de bezoeker niets opnieuw hoeft in te vullen.
export const toWizardPrefill = (f, result) => {
  const frames = f.area_mode === "maten" ? validFrames(f.frames) : [];
  const count = frames.reduce((s, x) => s + x.quantity, 0);
  const m2 = (num(f.glass_m2) || 0) + (num(f.glass_hr_m2) || 0);
  const dims = frames.length ? frames.map((x) => `${x.quantity}× ${x.width_mm} × ${x.height_mm} mm${KIND_LABEL[x.kind]}`).join("; ")
    : m2 ? `Ca. ${String(m2).replace(".", ",")} m² glas inclusief kozijnen (uit de subsidiecheck)` : "";
  const glass = productGlass(f.product) || (f.glass && f.glass !== "onbekend" ? f.glass : null);
  return {
    product: wizardProduct(f), glazing: glass, quantity: count ? (count === 1 ? "1" : count <= 3 ? "2-3" : count <= 6 ? "4-6" : "7+") : null,
    dimensions: dims.slice(0, 300), home_type: f.home_type || null, woonplaats: f.woonplaats.trim().slice(0, 80),
    timeline: f.work_status === "uitgevoerd" ? null : timeline(f.planned_year), isde_check_id: result.calculation_id,
    isde_status: result.status, isde_amount: result.amount,
  };
};
